$(document).on('click', '.module--faqs__items__item__question', function() {
  $('.module--faqs__items__item__question').not($(this)).find('i').removeClass('fa-minus').addClass('fa-plus');
  var $faq = $(this).parent('.module--faqs__items__item');
  $faq.find('.module--faqs__items__item__question i').toggleClass('fa-minus fa-plus');
  $faq.siblings('.module--faqs__items__item').find('.module--faqs__items__item__answer').hide();
  $faq.find('.module--faqs__items__item__answer').slideToggle();

  var targetOffset = $(this).offset().top - $('.header').height() - 25;
  $('html, body').animate({
    scrollTop: targetOffset,
  }, 'swing');
});

// $(document).on('click', '.module--faq-advanced__items__question__title', function() {
//   $('.module--faq-advanced__items__question__title').not($(this)).find('i').removeClass('fa-minus').addClass('fa-plus');
//   var $faq = $(this).parent('.module--faq-advanced__items__question');
//   $faq.find('.module--faq-advanced__items__question__title i').toggleClass('fa-minus fa-plus');
//   $faq.siblings('.module--faq-advanced__items__question').find('.module--faq-advanced__items__question__answer').hide();
//   $faq.find('.module--faq-advanced__items__question__answer').slideToggle();

//   var targetOffset = $(this).offset().top - $('.header').height() - 25;
//   $('html, body').animate({
//     scrollTop: targetOffset,
//   }, 'swing');
// });

$(document).on('click', '.module--faq-advanced__items__question__title', function() {
  var $faq = $(this).parent('.module--faq-advanced__items__question');
  $faq.find('.module--faq-advanced__items__question__title i').toggleClass('fa-minus fa-plus');
  $faq.find('.module--faq-advanced__items__question__answer').slideToggle();
});

